module.exports = __webpack_public_path__ + "img/art-home_2x.27ae1b57.png";